@if ({
  request: request$ | async,
  }; as content) {
  @if (showMessage) {
    <alert [alert]="alert"></alert>
  }
}
